import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';

const BrutalistPricing = () => {
  const plans = [
    {
      name: 'Маленький',
      area: '1-3 м²',
      price: 'Звоните',
      features: ['Доступ 24/7', 'Охрана', 'Видеонаблюдение', 'Сухой склад'],
      highlight: false
    },
    {
      name: 'Средний',
      area: '4-8 м²',
      price: 'Звоните',
      features: ['Доступ 24/7', 'Охрана', 'Видеонаблюдение', 'Сухой склад', 'Тележка'],
      highlight: true
    },
    {
      name: 'Большой',
      area: '9-15 м²',
      price: 'Звоните',
      features: ['Доступ 24/7', 'Охрана', 'Видеонаблюдение', 'Сухой склад', 'Прямой подъезд'],
      highlight: false
    }
  ];

  return (
    <section className="py-24 px-6 bg-background text-foreground">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-6xl font-sans font-bold uppercase mb-16 tracking-tighter">
          Тарифы
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`
                relative p-8 border transition-all duration-300
                ${plan.highlight 
                  ? 'border-accent scale-105 shadow-[8px_8px_0px_0px_rgba(230,59,46,1)] z-10 bg-card' 
                  : 'border-border hover:border-foreground bg-card hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]'
                }
              `}
            >
              {plan.highlight && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-accent-foreground px-4 py-1 font-mono text-xs uppercase tracking-widest">
                  Популярный
                </div>
              )}
              
              <div className="mb-8">
                <h3 className="text-2xl font-mono uppercase mb-2">{plan.name}</h3>
                <div className="text-4xl font-sans font-bold">{plan.price}</div>
                <div className="text-sm text-muted-foreground font-mono mt-1">+7 918 436-22-55</div>
              </div>

              <div className="mb-8 space-y-4 font-mono text-sm">
                <div className="flex justify-between border-b border-border pb-2">
                  <span>Площадь</span>
                  <span className="font-bold">{plan.area}</span>
                </div>
                {plan.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-3">
                    <Check className={`w-4 h-4 ${plan.highlight ? 'text-accent' : 'text-foreground'}`} />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/catalog"
                className={`
                  flex items-center justify-center gap-2 w-full py-4 font-mono uppercase text-sm tracking-widest transition-colors
                  ${plan.highlight 
                    ? 'bg-accent text-accent-foreground hover:bg-accent/90' 
                    : 'bg-foreground text-background hover:bg-accent hover:text-accent-foreground'
                  }
                `}
              >
                Выбрать
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrutalistPricing;
